// extracted by mini-css-extract-plugin
export default {"modalElement":"styles_modalElement__+CUF7","closeContainer":"styles_closeContainer__6q0d1","content":"styles_content__ogkmx"};